export default [
  {
    image: {
      round: false,
      portrait: {
        webp: "erlend-simensen-p.webp",
        jpg: "erlend-simensen-p.jpg",
      },
      landscape: {
        webp: "erlend-simensen-l.webp",
        jpg: "erlend-simensen-l.jpg",
      },
      fallback: "erlend-simensen-l.jpg",
    },
    name: "Erlend Osland Simensen",
    anchor: "erlend-osland-simensen",
    age: 34,
    location: "Oslo",
    map: {
      part: "south",
      x: 110,
      y: 210,
    },
    intro:
      "Medgründer av Dapper AS, som driver konseptbutikken ved samme navn, som holder åpent. Daglig leder for den tilstøtende kafeen/vinbaren, som er stengt på kveldstid. Medeier i barbersalongkjeden PelsPels, som er stengt.",
    quote:
      "Mer enn 30 ansatte permittert. En liten andel igjen for å holde hjulene i gang.",
    bodytext: [
      "&horbar; Det er utfordrende tider for alle små og mellomstore butikker. Også kjedene, som allerede sliter en god del. Jeg tror vi vil se en slags butikkdød, på mange måter. Så får man se hvordan man klarer å vri det til noe positivt.",
      "Vi driver jo med mye forskjellig, og har drevet med mye forskjellig ganske lenge, og det er jo en utfordrende ting, men vi får litt betalt for det nå, i og med at vi har gode netthandelsløsninger. Når folk ikke går ut, handler de mer på nett. Spesielt barberingsprodukter, såper og hygieneartikler som ikke er helt apotek.",
      "Dapper er mer i premiumsjiktet prismessig, det er kanskje ikke det man hamstrer i disse tider. Men det er fortsatt kunder som kommer innom og sier de aktivt ønsker å støtte – det er ikke sikkert de trenger den skjorta i dag, men likevel.",
      "Det er bra for moralen. Det er en usikker situasjon for veldig mange i handel-, uteliv-og servicebransjen. Jeg tror ikke man skal kimse av den psykiske påkjenningen det er for veldig mange ansatte i disse bransjene akkurat nå.",
      ],
  },
  {
    image: {
      round: false,
      portrait: {
        webp: "john-harald-knutsson-p.webp",
        jpg: "john-harald-knutsson-p.jpg",
      },
      landscape: {
        webp: "john-harald-knutsson-l.webp",
        jpg: "john-harald-knutsson-l.jpg",
      },
      fallback: "john-harald-knutsson-l.jpg",
    },
    name: "John Harald Knutsson",
    anchor: "john-harald-knutsson",
    age: 47,
    location: "Oslo",
    map: {
      part: "south",
      x: 110,
      y: 210,
    },
    intro:
      "Daglig leder for Revir, uavhengig friluftslivsbutikk med kaffebar, galleri og foredragstilbud ved Operapassasjen i Storgata.",
    quote:
      "Holder såvidt koken, men er forsiktig optimistisk.",
    bodytext: [
      "&horbar; Jeg har jo egentlig troen på småbutikken, selv om vi har hatt en tøff sesong. Jeg liker  ikke sånn sentimental meme-sutring om at «du må bruke butikkene i dag om du vil ha dem i morgen». Småbutikkene må være relevante, og ikke noe nostalgisk vi skal ta vare på som museumsgjenstander. Vi har hatt tre og tre kvart år med sunn vekst i en sportsbransje i fritt fall, og er trygge på at konseptet vårt er økonomisk bærekraftig og skalerbart. Men vi er jo sjukt sårbare for uforutsette hindre – slik som graving i gaten, dårlige vintre og globale pandemier. Eller alle tre på rad, da.",
      "Etter tre tøffe steg tilbake ser vi nå fremover mot en vår og sommer der nærturen vil stå i fokus. Mange vil få øynene opp for de kortreiste turene. Det har vært bærebjelken i konseptet vårt og noe vi har gnålt om siden oppstarten. Om noen drev med social distancing før det ble populært, var det oss.",
    ],
  },
  {
    image: {
      round: true,
      portrait: {
        webp: "catharina-maria-bugge-p.webp",
        jpg: "catharina-maria-bugge-p.jpg",
      },
      landscape: {
        webp: "catharina-maria-bugge-l.webp",
        jpg: "catharina-maria-bugge-l.jpg",
      },
      fallback: "catharina-maria-bugge-l.jpg",
    },
    name: "Catharina Maria Bugge",
    anchor: "catharina-maria-bugge",
    age: 54,
    location: "Rjukan",
    map: {
      part: "south",
      x: 70,
      y: 215,
    },
    intro:
      "Daglig leder for Aktiv Partner Italia, som organiserer turer, arrangementer og opplevelser for mindre norske turistgrupper i Roma og Italia forøvrig.",
    quote:
      "Alt som vi har jobbet med, er kollapset.",
    bodytext: [
      "&horbar; Jeg sitter i Roma, jeg. Fordi det er her jeg skulle ha jobbet fra. Men nå er det totalt portforbud. Det er en krise. Det er en veldig vanskelig situasjon å stå oppi, også bedriftsmessig.",
      "Men Roma har egentlig klart seg veldig bra. De stengte ned før viruset kom ordentlig inn. Det har vært ... jeg vet ikke om jeg kan bruke ordene «under kontroll» &hellip; men det har ikke tatt helt av.",
      "Og det er en ekstrem solidaritet som har dukket opp. Det er flere steder hvor det settes ut pasta og olje på benker til dem som ikke får handlet. Jeg ser det utenfor der jeg bor. Jeg ser at mange flere gir uteliggere penger nå.",
      "Jeg elsker denne byen. Den er som et annet hjem. Så jobben min er en måte å kunne være her på. Det er egentlig bare en drøm. Eller akkurat nå er det ikke en drøm. Men det tror jeg ikke det er i Norge, heller.",
      "Det som er så trist, hvis man ser det fra et norsk synspunkt, er at her er det full vår og på våren er Roma vakrest. Det synes jeg er trist, for alle de som hadde tenkt å komme ned nå, og det er mange.",
      "Det som er positivt – eller jeg skal ikke si at det er direkte positivt, men Roma har jo vært overbelastet med turisme, og det tar nok tid før vi er tilbake til masseturisme. Det kan kanskje være sunt med en <em>timeout</em>. Men jeg håper høstsesongen tar seg opp. Jeg tenker nok at verden kommer tilbake til en slags normal igjen. Og at mennesker vil tilbake til Roma.",
    ],
  },
  {
    image: {
      round: false,
      portrait: {
        webp: "kim-robertsen-p.webp",
        jpg: "kim-robertsen-p.jpg",
      },
      landscape: {
        webp: "kim-robertsen-l.webp",
        jpg: "kim-robertsen-l.jpg",
      },
      fallback: "kim-robertsen-l.jpg",
    },
    name: "Kim Robertsen",
    anchor: "kim-robertsen",
    age: 31,
    location: "Oslo",
    map: {
      part: "south",
      x: 110,
      y: 210,
    },
    intro:
      "Daglig leder for engrosfirmaet Germstar Norway AS, som selger «håndrensende produkter av høyeste kvalitet» – bord-, gulv- og veggdispensere med bevegelsesaktivert sensor – til bedriftskunder.",
    quote:
      "Antall henvendelser har skutt i taket.",
    bodytext: [
      "&horbar; Jeg la merke til dispenserne på en cruiseferie og syntes det så skikkelig lekkert ut, så jeg inviterte meg til en messe i Budapest og fikk norsk agentur før jul. Jeg tenkte det kunne være tøft å få innpass i markedet, for Antibac er så synonymt med det – man sier ikke håndsprit, man sier Antibac. Så jeg siktet meg inn mot bedriftsmarkedet, til å begynne med, segmentert mot kontorer, cruiseskip, kinoer og så videre. Det var utgangspunktet. Men denne situasjonen forandret alt det. Nå var det alt og alle som skulle ha. Koste hva det koste vil.",
      "Det er synd, så klart, men for oss har det vært en braksuksess. Utfordringen er at vi er tomt på lager. Så det er en suksess med bismak. Et luksusproblem, kanskje, men tross alt kjedelig. Det er veldig kjedelig å ikke ha det folk vil ha. Vi må ta bestillinger med klar beskjed om at leveringsdatoen er ubestemt, for det er en ganske lang verdikjede: Det er egentlig et amerikansk selskap, men mekanismen i dispenseren, som er veldig presis, kommer fra Sveits. Så må det til Kina for montering og sendes tilbake til Europa. Kina har litt begrenset kapasitet og skipsfart akkurat nå, og flyfrakt er både vanvittig dyrt og ikke så bærekraftig. Men jeg tenker også at det vil være etterspørsel etter produktet vårt på lang sikt. Denne situasjonen skaper et større behov i markedet, vil jeg tro.",
    ],
  },
  {
    image: {
      round: false,
      portrait: {
        webp: "hans-granerud-p.webp",
        jpg: "hans-granerud-p.jpg",
      },
      landscape: {
        webp: "hans-granerud-l.webp",
        jpg: "hans-granerud-l.jpg",
      },
      fallback: "hans-granerud-l.jpg",
    },
    name: "Hans-Øivind Granerud",
    anchor: "hans-oeivind-granerud",
    age: 25,
    location: "Alta/Oslo",
    map: {
      part: "north",
      x: 195,
      y: 45,
    },
    intro:
      "Tryllekunstner og konferansier som jobber eksklusivt med firmaarrangementer, under artistnavnet Hans Grane.",
    quote:
      "Alle konferanser, kick off og samlinger er avlyst. Hele innteksgrunnlaget bortfalt.",
    bodytext: [
      "&horbar; Jeg er på Barbados nå. 10. mars forsvant alle mine oppdrag, så jeg forsto at det her går bare en vei, og satte meg på flyet like før reiseforbudet trådte i kraft, for å være med kjæresten min, som er fra Barbados og jobber på en restaurant her.",
      "Her har de en litt annen tilnærming. De har vært borti mange andre virus – for ikke å snakke om orkaner – og er vant til å håndtere usikre områder. Men nå har de stengt ned alt sammen, fordi det ikke er noen turister. Bortsett fra meg, da. Men jeg vil ikke si at det føles som en ferie. Til det er alt for uvisst. Det er så lite prognoser for hvor lenge ting skal vare. Men jeg har jobbet fulltid med dette siden 2012 og hatt en omsetning på godt over millionen i året, så jeg har ikke noe problem med å leve et halvt år i uvisshet. Jeg kan jobbe med nettsiden min og trene og utvikle faget mitt – trylleteknisk kan man jo trene på egen hånd. Men man er jo litt avhengig av publikum. Det er litt rart å ikke ha publikum. Man kan kanskje ikke klage når det er 28 varmegrader, mens det snør to meter i Alta. Men jeg er her mest fordi kjæresten min er her. Vi ser hverandre ikke så mye til vanlig, så det er en mulighet til det, på godt og vondt.",
      
    ],
  },
  {
    image: {
      round: true,
      portrait: {
        webp: "line-levang-p.webp",
        jpg: "line-levang-p.jpg",
      },
      landscape: {
        webp: "line-levang-l.webp",
        jpg: "line-levang-l.jpg",
      },
      fallback: "line-levang-l.jpg",
    },
    name: "Line Levang",
    anchor: "line-levang",
    age: 48,
    location: "Bangsund i Namsos kommune",
    map: {
      part: "south",
      x: 165,
      y: 25,
    },
    intro:
      "Ansatt, leder for og eier av Vollen Hundepensjonat AS.",
    quote:
      "Status er at jeg er 80 prosent permittert. Men vi skal klare oss i noen måneder.",
    bodytext: [
      "&horbar; Vi driver et lite hundepensjonat. Våre hovedkunder er feriefolk, skiftarbeidere, møtegrupper fra bedrifter, sosiale og familiære arrangement og anleggsarbeidere. Alle har avbestilt som følge av Covid-19, og de delene av bedriften står helt uten oppdrag fremover. Vi er to ansatte. Vi har også en tømrer i bedriften. Han jobber fortsatt. Det er mannen min.",
      "Vi kjøpte plassen for litt over to år siden. Vi hadde et ganske bra år i fjor. Det startet veldig bra i år. Så ble det stille. Avbestillingene kom veldig tett, nærmest på røde rappen. Men jeg har tatt på meg stell, så jeg får nok til å betale strømregningen. Det var en hundesalongeier i Namsos sentrum, som gikk konkurs i fjor. Da hun gjorde det, bygde jeg en salong her. Hun var over og lærte meg opp. Nå har hun flyttet, så da blir det til at jeg har tatt over det i Namsos.",
      "Ellers er det veldig stille og rolig. Jeg har ikke noen pensjonatgjester. Luftegården er helt tom. Det er bare våre egne hunder igjen. Tre gamle jakthunder som lever sånn som de pleier: Ligger inne og sover.",
    ],
  },
  {
    image: {
      round: true,
      portrait: {
        webp: "eivind-berre-p.webp",
        jpg: "eivind-berre-p.jpg",
      },
      landscape: {
        webp: "eivind-berre-l.webp",
        jpg: "eivind-berre-l.jpg",
      },
      fallback: "eivind-berre-l.jpg",
    },
    name: "Eivind Berre",
    anchor: "eivind-berre",
    age: 56,
    location: "Namsos",
    map: {
      part: "south",
      x: 165,
      y: 25,
    },
    intro:
      "Bassist i D.D.E og daglig leder i deres driftsselskap Rai Rai Entertainment.",
    quote:
      "Permitterer alle ansatte og avbestiller alle underleverandører.",
    bodytext: [
      "&horbar; Det er nå det begynner for oss. Rett etter påske. Det er da det skjer. 75 prosent av bedriftens årsproduksjon skjer normalt fra påske til september. Men den usikkerheten som rår nå, gjør at arrangører kansellerer alt. Alle kontrakterte oppdrag fram til 1. juni er kansellert, samt enkelte langt uti juni og i august. Det innebærer at hele «sesongen» står i fare for å ryke.",
      "Noen av oss er også med i et tributeband til Bruce Springsteen (Namsos Allstar, som består av medlemmer fra D.D.E, Sambandet, Terje Tysland Band og Grannes, samt soloartisten Thomas Brøndbo, red. anm.). Sist helg heiv vi oss rundt og gjorde en Facebook-konsert. Fordelt på tre rom overholdt vi smitteverntiltakene. Men livestreaming er ikke noe å tjene penger på i lengden. Du kan ikke gjøre det en hel sesong. Du holder ikke et helt apparat i gang, det blir mer for å sette det man holder på med i fokus. Så vi har tenkt å få til en nettkonsert med D.D.E i løpet av påsken. Digital afterski. Det er en helt ny verden.",
    ],
  },
  {
    image: {
      round: false,
      portrait: {
        webp: "madlena-tsvetkova-p.webp",
        jpg: "madlena-tsvetkova-p.jpg",
      },
      landscape: {
        webp: "madlena-tsvetkova-l.webp",
        jpg: "madlena-tsvetkova-l.jpg",
      },
      fallback: "madlena-tsvetkova-l.jpg",
    },
    name: "Madlena Tsvetkova",
    anchor: "madlena-tsvetkova",
    age: 34,
    location: "Oslo",
    map: {
      part: "south",
      x: 110,
      y: 210,
    },
    intro:
      "Daglig leder for Pyroteknikk.no, som leverer pyroteknikk, fyrverkeri, spesialeffekter og laserteknologi til underholdningsbransjen.",
    quote:
      "Vi har permittert alle våre ansatte 100 prosent siden tiltakene trådte i kraft.",
    bodytext: [
      "&horbar; Vi har hatt en enorm omsetningsnedgang. Mer eller mindre forsvunnet over natten. Og vi er selvfølgelig usikre på hvordan fremtiden kommer til å se ut. For sommeren er høysesongen. Vi er avhengige at store arrangementer skjer, for å kunne levere. Vi leverer til de fleste store. Landstreffet til russen i Stavanger. «We Love the 90s» på Telenor Arena. Infernofestivalen i påsken. Kvelertak. Cezinando har brukt oss. Karpe Diem skal ikke ha noe før neste år, heldigvis.",
      "Men det er ikke så veldig mye vi kan gjøre. Hvis man nå må streame konserter, er det selvfølgelig begrenset hvor mye spesialeffekter man kan trekke inn. Scene-, lyd- og kameraproduksjon klarer å finne alternative ting. Men hvis budsjettene er mindre, dropper man det man kan droppe. Da er det kanskje ikke så aktuelt med pyro.",
      "Men vi er ikke isolerte aktører. Musikkarrangører og kulturlivet og sceneteknisk produksjon er veldig sterkt avhengig av hverandre. Alle ledd henger sammen. Det er ingen som kan garantere at selskapene i bransjen klarer å komme seg på bena etter at det igjen åpnes for arrangementer, fordi de også er avhengige av at arrangørene overlever og at folk fremdeles har midler og tør å satse.",
    ],
  },
  {
    image: null,
    name: "Robin Kristiansen",
    anchor: "robin-kristiansen",
    age: 23,
    location: "Tromsø",
    map: {
      part: "north",
      x: 125,
      y: 65,
    },
    intro:
      "Drosjesjåfør",
    quote:
      "Etter de nye tiltakene og alle som er i karantene, er det ikke stort mer arbeidsgrunnlag enn at man får råd til en pakke tyggis på en arbeidsdag.",
    bodytext: [
      "&horbar; Sjefen prøver å holde hjulene i gang, så jeg kjører fortsatt. Jeg er ikke redd for å ta kunder, jeg er flink til å desinfisere, men jeg har litt sånn <em>mixed feelings</em>. Jeg skulle helst se at at alle holdt seg hjemme til det blåste over, men samtidig har jeg lyst til å ha noe å gjøre. Her i Tromsø er alt stengt, men det har vært noen hjemmefester og sånn. I går kjørte jeg fra klokken tre på ettermiddagen til fem på morgenen. Det sliter litt på hodet og kroppen, du føler ikke at du har samme kalender som vanlige folk. Egentlig skulle jeg gjort alt annet enn å kjøre drosje. Jeg har et fagbrev i elektrofag, men var litt ubesluttsom etter skolen og valgte å gå en annen vei. Fornuften har kommet tilbake siden den tid. Nå vurderer jeg å bruke fagbrevet til noe. Det er mulig det her kan litt være litt det kicket i baken jeg trengte.",
    ],
  },
];